<template>
  <CreateModal type="transfer" ref="createModal" :customCallButton="true">
    <div class="mw-700 mx-auto">
      <h-loading v-if="isLoading" />
      <v-form v-show="!isLoading" class="py-5" ref="payHost">
        <h1 class="mw-500 mb-10">
          {{ $t('payment.hint.addToTransferList') }}
        </h1>

        <div class="payments-list">
          <div v-for="invoice in hostInvoices" :key="invoice.month_name">
            <p class="headline mb-0 font-weight-light mb-2">
              {{ invoice.month_name }}
            </p>

            <PaymentFortnight
              v-if="isNotEmpty(invoice.first_half)"
              @insertPayments="insertSelectedPayments"
              @deletePayments="removeDeselectedPayments"
              :fortnight="invoice.first_half"
              :selectedPayments="payments"
              :key="payments.length+1"
              title="firstHalf"
            />

            <PaymentFortnight
              v-if="isNotEmpty(invoice.second_half)"
              @insertPayments="insertSelectedPayments"
              @deletePayments="removeDeselectedPayments"
              :fortnight="invoice.second_half"
              :selectedPayments="payments"
              :key="payments.length"
              title="secondHalf"
            />
          </div>
        </div>

        <v-row no-gutters class="mt-10">
          <v-col class="d-flex justify-start">
            <HCheckbox :input-value="allPaymentsSelected" @input="selectAllPayments($event)" label="Selecionar todos os pagamentos" />
          </v-col>
          <v-col class="d-flex justify-end">
            <span class="font-weight-bold mr-2">Total:</span>
            {{ formatMonetary(payments.map(it => it.value).reduce((a, b) => a + b, 0)) }}
          </v-col>
        </v-row>

        <div class="d-flex justify-end mt-10">
          <v-btn
            @click="$refs.createModal.closeCreateModal()"
            :disabled="isGeneratingTransfers"
            class="grey--text mr-5"
            elevation="0"
            large
            text
          >
            {{ $t('payment.list.actions.cancel') }}
          </v-btn>

          <v-btn
            @click="pay"
            :loading="isGeneratingTransfers"
            color="primary"
            elevation="0"
            large
          >
            {{ $t('payment.list.actions.createTransfer') }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </CreateModal>
</template>

<script>
import CreateModal from '@/components/app/CreateModal'
import HCheckbox from '@/components/app/HCheckbox'
import PaymentFortnight from './components/PaymentFortnight'
import { mapGetters, mapActions } from 'vuex'
import { isObjectEmpty } from '@/util/helpers'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'ModalPayHost',

  data() {
    return {
      payments: [],
      hostId: null,
      isGeneratingTransfers: false,
      formatMonetary: catalogMonetary,
      allPaymentsSelected: false,
    }
  },

  components: {
    CreateModal,
    PaymentFortnight,
    HCheckbox
  },

  computed: {
    ...mapGetters(['isLoading', 'hostInvoices']),
  },

  methods: {
    ...mapActions([
      'callPayHost',
      'fetchPayments',
      'showErrorMessage',
      'fetchHostInvoices',
      'createIntegration',
      'showSuccessMessage',
    ]),

    openModal(hostId) {
      this.fetchHostInvoices(hostId)
      this.hostId = hostId
      this.payments = []
      this.$refs.createModal.openCreateModal()
    },

    paymentsId(paymentsArray) {
      return paymentsArray.map((payment) => payment.id)
    },

    insertSelectedPayments(payments) {
      this.allPaymentsSelected = false
      for (var payment of payments) {
        if (!this.payments.includes((it) => it.payment == payment.id)) {
          this.payments.push(payment)
        }
      }
    },

    selectAllPayments(checkboxValue) {
      this.allPaymentsSelected = checkboxValue
      const allPayments = [];

      const processInvoice = (invoice) => {
        if (invoice) {
          Object.values(invoice).forEach((customer) => {
            Object.values(customer.branches).forEach((branch) => {
              allPayments.push(...branch.payments);
            });
          });
        }
      };

      Object.values(this.hostInvoices).forEach((invoice) => {
        processInvoice(invoice.first_half);
        processInvoice(invoice.second_half);
      });

      this.payments = checkboxValue ? allPayments : [];
    },


    removeDeselectedPayments(payments) {
      this.allPaymentsSelected = false
      for (var payment of payments) {
        this.payments = this.payments.filter((it) => it.id != payment.id)
      }
    },

    pay() {
      this.isGeneratingTransfers = true

      this.callPayHost(this.buildRequestBody())
        .then(() => this.finishPay())
        .catch(({ data }) => this.handleErrorMessage(data))
        .finally(() => this.isGeneratingTransfers = false)
    },

    finishPay() {
      this.fetchPayments()
      this.$refs.createModal.closeCreateModal()
      this.showSuccessMessage(this.$t('payment.messages.transferGenerated'))
    },

    handleErrorMessage(data) {
      if (!data?.errors && !data?.errors?.length) this.finishPay()
      this.showErrorMessage(this.$t('payment.createTransfer.label.' + data.errors[0].field) + ': ' + data.errors[0].message)
    },

    buildRequestBody() {
      var paymentIds = this.payments.map((payment) => payment.id)

      return {
        payments_ids: paymentIds,
        host_id: this.hostId,
      }
    },

    isNotEmpty(object) {
      return !isObjectEmpty(object)
    },
  },
}
</script>

<style scoped>
.payments-list {
  overflow: auto;
  max-height: 50vh;
}
</style>
